<template>
  <span :class="['td-data', {'paused': paused}]" ref="con">
    <template v-if="!disabled">
      <i class="icon icon--heatmap-state" :class="[pageData.heatmapUiState || pageData.heatmapState, {'paused': paused}]"
         @click="onChangeHeatmapState(pageData, idx)">
        <ui-icon-tooltip
            v-if="pageData.heatmapState === 'stopByDomainCreditEmpty' || pageData.heatmapState === 'stopByUserCreditEmpty' || pageData.heatmapState === 'stopByJamPvEmpty'"
            :iconName="'icon--heatmap-state-warning'" :style="{ 'position': 'absolute', 'left': '53px', 'top': '-3px' }"
            arrowBottom arrowCenter>
          <span v-html="getEndByTooltip(pageData.heatmapState)"></span>
        </ui-icon-tooltip>
        <i v-else-if="pageData.heatmapUiState === 'scheduledRun'" class="icon icon--heatmap-state-warning-schedule" :style="{ 'position': 'absolute', 'left': '53px', 'top': '-3px' }"></i>
      </i>
      <i v-if="pageData.heatmapState !== 'none' && pageData.heatmapState !== 'endByAnalysisDate'"
         class="icon icon--heatmap-setting" @click="onHeatmapRegisterAction"></i>
    </template>
    <template v-else>
      <i class="icon icon--heatmap-state disabled" @mouseover="tooltipOn()" @mouseleave="tooltipOff()">
        <ui-tooltip
            v-show="openDisableTooltip"
            :style="tooltipStyle"
            :arrowBottom="bindArrowBottom"
            :arrowTop="bindArrowTop"
            arrowCenter>
          <span v-html="$t('heatmap.list.oldCodeTooltip')">
          </span>
        </ui-tooltip>
      </i>
    </template>

  </span>
</template>
<script>
import UiIconTooltip from '@/components/ui/UiIconTooltip'
import { HEATMAP_STATE } from '@/libs/constants'
import UiTooltip from '@/components/ui/UiTooltip.vue'

export default {
  components: {
    UiTooltip,
    UiIconTooltip
  },
  props: [
    'idx',
    'pageData',
    'selectNode',
    'selectedState',
    'isHeatmapRun',
    'isHeatmapStop',
    'onHeatmapRegister',
    'disabled',
    'paused'
  ],
  data () {
    return {
      openDisableTooltip: false,
      bindArrowBottom: true,
      bindArrowTop: false
    }
  },
  computed: {
    tooltipStyle () {
      let result = {
        'bottom': '50px'
      }
      if (this.bindArrowTop) {
        result = {
          'top': '50px'
        }
      }

      return result
    }
  },
  methods: {
    tooltipOn () {
      const y = this.$refs.con.getBoundingClientRect().top
      if (y < 350) {
        this.bindArrowBottom = false
        this.bindArrowTop = true
      } else {
        this.bindArrowBottom = true
        this.bindArrowTop = false
      }

      this.openDisableTooltip = true
    },
    tooltipOff () {
      this.openDisableTooltip = false
    },
    getEndByTooltip (type) {
      let result
      if (type === 'stopByDomainCreditEmpty') {
        result = this.$t('heatmap.registration.tooltip.stopByDomainCreditEmpty')
      } else if (type === 'stopByUserCreditEmpty') {
        result = this.$t('heatmap.registration.tooltip.stopByUserCreditEmpty')
      } else if (type === 'stopByJamPvEmpty') {
        result = this.$t('heatmap.registration.tooltip.stopByJamPvEmpty')
      }
      return result
    },
    onChangeHeatmapState (item, index) {
      this.$emit('selectedState', item.heatmapState)
      this.$emit('selectNode', {
        data: item,
        index: index
      })
      if (item.heatmapState === HEATMAP_STATE.NONE ||
        item.heatmapState === HEATMAP_STATE.STOP ||
        item.heatmapState === HEATMAP_STATE.ENDBYANALYSISDATE) {
        this.$emit('isHeatmapRun', true)
      }

      if (item.heatmapUiState === HEATMAP_STATE.SCHEDULEDRUN) {
        this.$emit('isHeatmapSet')
      }
      if (item.heatmapState === HEATMAP_STATE.RUN ||
        item.heatmapUiState === HEATMAP_STATE.ERROR ||
        item.heatmapState === HEATMAP_STATE.STOPBYDOMAINCREDITEMPTY ||
        item.heatmapState === HEATMAP_STATE.STOPBYUSERCREDITEMPTY ||
        item.heatmapState === HEATMAP_STATE.STOPBYJAMPVEMPTY) {
        this.$emit('isHeatmapStop', true)
      }
    },
    onHeatmapRegisterAction () {
      this.$emit('onHeatmapRegister', this.pageData, this.idx)
    }
  }
}
</script>
<style lang="scss" scoped>
.td-data {
  .icon--heatmap-state {
    position: relative;
    padding-right: 50px;
    top: 3px;

    &.disabled {
      cursor: auto;
      & i {
        //top: -60px;
        left: 50%;
        transform: translate(-50%, 0);
        z-index: 999999;
      }
    }

    & /deep/ a {
      display: inline-block;
      color: #0074FF;
      height: 18px;
      margin-top: 12px;

      & i {
        top: 1.5px;
        position: relative;
        margin-right: 3px;
      }

      & span {
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
      }
    }
  }

  .icon--heatmap-setting {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    right: 20px;
  }

  &.paused {
    filter: grayscale(1);
    .icon--heatmap-state {
      span, i {
        opacity: .3;
      }
    }
    .icon--heatmap-setting {
      opacity: .3;
    }
  }
}
</style>
